@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.modal {
  width: 375px;
}

.content {
  color: @returns-unsaved-changes-modal--text-color;
  font-size: 13px;
}
